import React from 'react';
import { Form, Radio } from 'antd';
import PropTypes from 'prop-types';
import { CustomInput } from '../../../../atoms';
import {
  VALUE_TYPE_MONEY,
  VALUE_TYPE_PERCENTAGE,
} from '../../../../../services/repository/settingRepository/objects/setting';

function DefaultValueInput({ id, label, valueType, onChange, value }) {
  const handleOnChangeValueType = (e) => onChange(id, e.target.value, 0);
  const handleOnChangeValue = (changedValue) =>
    onChange(id, valueType, changedValue);

  return (
    <Form.Item label={label}>
      <Radio.Group value={valueType} onChange={handleOnChangeValueType}>
        <Radio value={VALUE_TYPE_PERCENTAGE}>Porcentagem (%)</Radio>
        <Radio value={VALUE_TYPE_MONEY}>Valor Fixo (R$)</Radio>
      </Radio.Group>

      {valueType === VALUE_TYPE_PERCENTAGE && (
        <CustomInput
          suffix="%"
          value={value}
          getValue={handleOnChangeValue}
          max={100}
        />
      )}
      {valueType === VALUE_TYPE_MONEY && (
        <CustomInput value={value} getValue={handleOnChangeValue} />
      )}
    </Form.Item>
  );
}

DefaultValueInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  valueType: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
};

export default DefaultValueInput;
